export default __webpack_public_path__ + "static/media/dc.3c23a5d3.png";